import { Box } from "@mui/material";

export default function MaintenancePage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#E6F0FA",
        p: { xs: 1.5, sm: 2 },
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/maintenance-notice.jpg`}
        alt="Service Maintenance Notice / 系统维护通知"
        sx={{
          display: "block",
          width: "min(720px, 100%)",
          maxWidth: "100%",
          height: "auto",
          borderRadius: 2,
          boxShadow: "0 4px 24px rgba(0, 64, 128, 0.12)",
        }}
      />
    </Box>
  );
}
